export const RELOAD_INTERVAL = 2000;

export const BROWSE_MODELS_LOCALSTORAGE_KEY = "browseModelsViewPreferences";
